var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.352,
    height: 43.434,
    viewBox: "0 0 43.352 43.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M43.516,33.269v6.086a4.058,4.058,0,0,1-4.423,4.058,40.149,40.149,0,0,1-17.508-6.228A39.561,39.561,0,0,1,9.413,25.012,40.149,40.149,0,0,1,3.184,7.423,4.058,4.058,0,0,1,7.222,3h6.086A4.058,4.058,0,0,1,17.365,6.49a26.049,26.049,0,0,0,1.42,5.7,4.058,4.058,0,0,1-.913,4.281L15.3,19.048A32.46,32.46,0,0,0,27.469,31.22l2.577-2.577a4.058,4.058,0,0,1,4.281-.913,26.049,26.049,0,0,0,5.7,1.42A4.058,4.058,0,0,1,43.516,33.269Z",
    transform: "translate(-1.666 -1.5)",
    fill: "none",
    stroke: "#ed8e88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRed);
export default __webpack_public_path__ + "static/media/phone-red.9bed27cbf676a3ee5d8e2b528920cf84.svg";
export { ForwardRef as ReactComponent };